import { createSelector } from '@reduxjs/toolkit';

const selectPlaces = state => state.places;

export const selectAllPlaces = createSelector(selectPlaces, state => state);
export const selectPlacesItems = createSelector(selectPlaces, state => state?.items ?? []);
